import axios from 'axios'
import { isJSON } from '../utils'
import {router} from '../main.js'
export const root_domin = 'https://api.xumeiniang.com'
// if (process.env.NODE_ENV === 'development') {
//     axios.defaults.baseURL = process.env.VUE_APP_API_URL
// }else{
//     axios.defaults.baseURL = `${window.location.protocol}//${window.location.hostname}`
// }
axios.defaults.baseURL = process.env.VUE_APP_API_URL
// console.log('axios.defaults.baseURL',axios.defaults.baseURL)

export const baseURL = axios.defaults.baseURL

const serverOkCode = 0;
const tokenErrorCode = 2;
function request(path, data={}) {
    console.log('before-request: ',path,data)
    const token = localStorage.getItem('token')
    const that = this
    if(token){
        data.token = token
    }
    data.lang = "1"
    return new Promise((resolve, reject) => {

        axios({
            method: "post",
            url: path,
            data,
            headers: {
			    'Content-Type': 'application/json',
                'Authorization':`Bearer ${token}`
			},
            // 处理跨域请求
            // withCredential: true
          }).then(res => {
            // 解构赋值
            console.log('request-success: ',res)
            const {code, data,message} = res.data
            if (code === serverOkCode) {
             
              return resolve(data)
            }else if(code == tokenErrorCode){
                localStorage.removeItem('token')
                localStorage.removeItem('uname')
               
                this.$router.replace("/login");
                return reject(message)
            } else {
                // 否则弹框提示警告错误
               return reject(message)
            }
          })
          .catch(err=>{
            console.log('request-err: ', err)

            const res = err.response

            if (res.status === 401 && res.statusText == "Unauthorized"){

                localStorage.removeItem('token')
                localStorage.removeItem('uname')
                
                router.replace("/login");

               return reject('登陆信息已过期')

            }
            // 关键：存在后端返回响应时，读取后端自定义message
            if (err.response && err.response.data) {
                const msg = err.response.data.message || '请求失败'
                return reject(msg)
            }
            // 无后端响应（网络/404/500等）兜底提示
            return reject('服务器连接失败')
          });
    })
}

export function admin_login(username,password){
      return request('/admin/login/login',{username,password})
}

export function admin_loginout(){
    return request('/admin/login/logout',{})
}

export async function shop_category_list(pid=0,keyword='',page=1,limit=20){
    return request('/admin/category/index',{pid,keyword,page,limit})
}

export async function all_category_list(){
    return request('/admin/category/tree')
}

export function edit_category({id=0,pid=0,name,sort=0,state}){
    return request('/admin/category/edit',{id,pid,name,sort,state})
}

export function delete_category(ids){
    return request('/admin/category/del',{ids})
}

export function get_languages(page=1,limit=20,id=0,keyword=''){
    return request('/admin/lang/index',{page,limit,id,keyword})
}

export function edit_language(id=0,name,sort=0,ecode=''){
    return request('/admin/lang/edit',{id,name,sort,ecode})
}

export function delete_languages(ids){
    return request('/admin/lang/del',{ids})
}

export async function goods_list(keyword='',id=0,category_id=0,page=1,limit=20){
    return request('/admin/goods/index',{keyword,id,category_id,page,limit})
}

export function delete_goods(ids){
    return request('/admin/goods/del',{ids})
}

// has_logo
export function edit_goods({id,name,info,brand_id,category_id,pics,cover,price,colors,state,sort,goods_num,is_top,store_num,description,has_logo,products,videoURL}){
    return request('/admin/goods/edit',{id,name,info,brand_id,category_id,pics,cover,price,colors,state,sort,goods_num,is_top,store_num,description,has_logo,products,videoURL})
}

export function all_filecategory_list(){
    return request('/admin/upload_category/tree')
}

/*
  id | integer | 否 | 非0编辑 0添加
  pid | integer | 否 | 父级ID
  name | string | 是 | 名称
  state | integer | 是 | 1上架 2下架
  sort | int | 否 | 排序
*/
export function eidt_filecategory({id,pid,name,state=1,sort=0}){
    return request('/admin/upload_category/edit',{id,pid,name,state,sort})
}

/**
 * 获取文件列表
 * 参数 | 类型 | 是否必传 | 说明
  --- | --- | --- | ---
  ctype | int | 是 | 1图片 2视频
  category_id | int | 是 | 分类ID
  page | integer | 否 | 页码 默认 1
  limit | integer | 否 | 每页个数，最大 100， 默认 20

 */
export function photo_list({ctype,category_id=0,page=1,limit=8,keyword=''}){
  return request('/admin/upload/index',{ctype,category_id,page,limit,keyword})
}

/**
 *  ctype | int | 是 | 1图片 2视频
    category_id | int | 是 | 分类ID
    file_nickname  | string | 是 | 文件名
    file_name | string | 是 | 唯一的文件名前端生成
    file_ext | string | 是 | 文件后缀 jpg png jpeg mp4
    file_content | string | 是 | base64 编码分隔的文件内容
 */
export async function photo_chunk_upload({ctype=1,category_id,file_nickname,file_name,file_ext,file_content,is_finished}){
    return request('/admin/upload/upload',{ctype,category_id,file_nickname,file_name,file_ext,file_content,is_finished})
}
/**
 * 文件删除-注意会删除实际文件
 * ids | string | 是 | 逗号分隔的ID
 */
 
export async function file_delete(ids) {
    return request('/admin/upload/del',{ids})
}

export async function deep_seek_trans({content,languages}){
    const baseURL = process.env.VUE_APP_DEEPSEEK_URL;
    const apiKey = 'sk-930c38a558c14477b28f7f192bb5c089';
    const url = '/v1/chat/completions'
    var temp_array = []
    // console.log('languages',languages)
    languages.forEach(lan => {
        const ecode = lan.ecode;
        const name = lan.name;
        temp_array.push(`${ecode}=${name}`)
    });
    var deal_content = `把"${content}"这${content.length}个字翻译成${languages.map(lan => lan.name).join(',')}。返回json字符串，格式为{"en":xxxx,"fr":yyy}，不要有其他符号，其中${temp_array.join(',')}。只返回译文，不要额外解释`;
    // console.log('del_content',deal_content)
    
    return new Promise((resolve, reject) => {
        axios({
            baseURL,
            url,
            method:'POST',
            data:{
                model: "deepseek-chat",
                messages: [
                    { role: "user", content: deal_content }
                ],
                temperature: 0.3,
                max_tokens: 1024,
            },
            headers:{
                "Authorization":`Bearer ${apiKey}`,
                "Content-Type": "application/json"
            },
            timeout:20000,
            // 处理跨域请求
            withCredential: true
          }).then(response => {
            console.log('deep_seek_trans',response.data)

            var str_result = response.data.choices[0].message.content;
        
            str_result = str_result.replace('```json\n','').replace('\n```','')
          
            const json_result = JSON.parse(str_result)
         
            return resolve(json_result)
          })
          .catch(error => {
            console.log('deep_seek_trans-error',error)
            return reject(error)
          });
    })
}

/**
 * 参数 | 类型 | 是否必传 | 说明
--- | --- | --- | ---
id | int | 否 | 咨询ID
user_id | int | 否 | 用户ID
goods_id | int | 否 |goods_id
page | int | 否 | 页码
limit | int | 否 | 每页限制条数 默认20
 */
export async function consult_list({id=0,user_id=0,goods_id=0,page=1,limit=20}){
    return request('/admin/consult/index',{id,user_id,goods_id,page,limit}) 
}

export async function consult_messages(consult_id,page,limit,sort=2){
	return request('/admin/consult/user_consult_message',{consult_id,page,limit,sort})
}

export async function reply_user_consult_message(consult_id,admin_message){
    return request('/admin/consult/add_user_consult_message',{consult_id,admin_message})
}

/**
 * field | string | 是 | day 日 month月 year年
 * page | integer | 否 | 页码 默认 1
 * limit | integer | 否 | 每页个数，最大 100， 默认 20
 */
export function statistics(field='day',page=1,limit=20){
    return request('/admin/index/statistics',{field,page,limit})
}

export function notice_list(){
    return request('/admin/notice/index')
}

export function notice_edit(notice){
    return request('/admin/notice/edit',{id:notice.id,end_timestamp:notice.end_timestamp,content:notice.content,start_timestamp:notice.start_timestamp,switch:notice.switch})
}

export function notice_del(id){
    return request('/admin/notice/del',{ids:id})
}

export function notices_del(ids){
    return request('/admin/notice/del',{ids})
}

/**
 * 
 * @param ctype 1 收藏 2浏览
 * @param btime 开始时间戳
 * @param etime 结束时间戳
 * @param page 1页码
 * @param limit 每页条数 默认 20
 */
export function goods_statistics({ctype=2,btime,etime,page=1,limit=20}){
    // if(!btime){
    //     btime = (Date.now()-48*3600*1000)/1000
    // }
    if(!etime){
        etime = Date.now()/1000
    }
    return request('/admin/index/goods_statistic',{ctype,btime,etime,page,limit})
}

// 管理员订单列表
export function order_list(params) {
  return request('/admin/order/list',params)
}

// 管理员订单详情
export function order_detail(orderSN) {
  return request(
     '/admin/order/detail', { order_sn: orderSN }
  )
}

export function order_reply({order_sn,remark}){
    return request('/admin/order/remark',{order_sn,remark})
}

export function order_status_modify({order_id,order_status}){
    return request('/admin/order/update_status',{order_id,order_status})
}

export function mailnotifylist(){
    return request('/admin/mailnotify/list')
}

export function mailnotifyswitch({code,enable}){
     return request('/admin/mailnotify/switch',{code,enable})
}

export function mailnotifyreceivers(code){
    return request('/admin/mailnotify/receivers',{code})
}

export function mailnotifyaddreveiver({code,mail}){
    return request('/admin/mailnotify/addReveiver',{code,mail})
}

export function mailnotifydelreveiver(id){
    return request('/admin/mailnotify/deleteReceiver',{id})
}

//banner，recommend

export function recommendlist({lang,page,limit}){
    return request('/admin/recommend/list',{lang,page,limit})
}

export function recommendsave({goods_id,sort}){
    return request('/admin/recommend/save',{goods_id,sort})
}

export function recommenddelete(id){
    return request('/admin/recommend/delete',{id})
}

export function recommendswitch({id,enable_switch}){
    return request('/admin/recommend/switch',{id,enable_switch})
}

export function recommendsort({id,sort}){
    return request("/admin/recommend/sort",{id,sort})
}

export function bannerlist(){
    return request('/admin/banner/list')
}

export function bannersave({id,title,image,jump_type,jump_val,sort,enable_switch}){
    return request('/admin/banner/save',{id,title,image,jump_type,jump_val,sort,enable_switch})
}

export function bannerdelete(id){
    return request('/admin/banner/delete',{id})
}

export function bannerswitch({id,enable_switch}){
    return request('/admin/banner/switch',{id,enable_switch})
}